/* eslint-disable eqeqeq */
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { getIsDesktop, Pages } from '../../../utils/Utils';
import BaseDesktopDialog from '../../../custom_views/BaseDesktopDialog';
import { useState, useRef } from 'react';
import { IMaskInput } from 'react-imask';
import { UsersApi } from '../../../api/UsersApi';
import Loader from '../../../custom_views/Loader';
import { AdsApi } from '../../../api/AdsApi';

function SeoWriteToExpertsDialog(props) {
    const [phoneNumber, setPhone] = useState("7")
    const [isLoading, setLoading] = useState(false)
    const [specialization, setSpecialization] = useState("")
    const ref = useRef(null)
    const inputRef = useRef(null)

    const isDesktop = getIsDesktop()
    const cancel = () => {
        props.setShow(false)
    }
    var isPhoneEntered = phoneNumber.length == 11
    var isPhoneError = false
    const onPhoneChange = (phone) => {
        if (phone == undefined || phone == ""){
            setPhone("")
            setPhone("7")
        } else {
            if (phone.length < 3){
                setPhone("7")
            } else {
                setPhone(phone)
            }
        }
    }
    const fastCreateRequestRepetitor = () => {
        setLoading(true)
        AdsApi.fastRequestRepetitor(props.searchTextH1, phoneNumber, () => {
            props.showToast("Запрос успешно отправлен")
            cancel()
            setLoading(false)
        }, () => {
            setLoading(false)
        })
       
    }
    const getInnerHtml = () => {
        return(
            <div style={{padding : '32px 14px', maxWidth : isDesktop ? '370px' : ''}} className="call_info_container relative">
                <div className='profile_free_lesson_t'>Связаться с репетитором</div>
{/* 
                <div className="profile_free_lesson_input profile_free_lesson_bg">
                    <p className='profile_free_l_t'>Предмет</p>
                    <input className="auth_phone_input profile_free_lesson_bg" placeholder="Например, русский язык" type="text" value={specialization} onChange={(e) => setSpecialization(e.target.value)}/>
                </div> */}
                <div className='seo_experts_dialog_desc'>Номер телефона</div>
                <div style={{paddingTop : '8px', marginTop : '8px', marginBottom : '8px'}} className="profile_free_lesson_input profile_free_lesson_bg">
                    {/* <p className='profile_free_l_t'>Телефон</p> */}
                    <IMaskInput type="tel" className="auth_phone_input profile_free_lesson_bg" mask={'+{7} (000) 000-00-00'} radix="." value={phoneNumber} unmask={true} // true|false|'typed'
                    ref={ref}
                    inputRef={inputRef}
                    onAccept={
                        (value, mask) => {
                            onPhoneChange(value)
                            console.log("value = " + value)
                        }
                    } placeholder='+7 (000) 000-00-00' />
                </div>
                <div style={{opacity : '0.5'}} className='seo_experts_dialog_desc'>Мы свяжемся с вами в течение 15 минут</div>
                <div onClick={fastCreateRequestRepetitor} style={(isPhoneEntered) ? {maxHeight : '52px'} : {pointerEvents : 'none', opacity : '0.2', maxHeight : '52px'}} className='profle_free_lesson_btn hover relative'>{isLoading ? <Loader style={{margin : '0'}}/> : "Связаться с репетитором"}</div>
                <div onClick={() => props.setShow(false)} style={{background: 'var(--2)', color : 'black', marginTop : '-24px'}} className='profle_free_lesson_btn hover'>Продолжить поиск</div>
                <div className='profle_free_lesson_privacy'>Отправляя форму, я подтверждаю, что мне есть 18 лет, и я соглашаюсь с <a rel="noreferrer" target='_blank' href={Pages.terms} style={{fontWeight : '700'}} className='hover'>Условиями использования и Политикой конфиденциальности</a></div>
            </div>
        )
    }
    if (isDesktop){
        if (!props.isShow){
            return(<div/>)
        } 
        return(<BaseDesktopDialog isShow={props.isShow} getInnerHtml={getInnerHtml} setShow={cancel}/>)
    } else {
        return (
            <BottomSheet style={{zIndex : 9999}} open={props.isShow} onDismiss={cancel}>
                {getInnerHtml()}
            </BottomSheet>
        )
    }
    
}

export default SeoWriteToExpertsDialog;
